<template>
  <div>
    <div class="Polaris-LegacyCard">
      <div class="Polaris-LegacyCard__Header">
        <h2
          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--semibold flex"
        >
          Welcome to Carthike!
        </h2>
      </div>
      <div class="Polaris-LegacyCard__Section">
        <div class="flex text-gray-500 items-center">
          <span class=""
            >{{ completedValue.completedFeatures }} of
            {{ completedValue.totalFeatures }} tasks complete</span
          >
          <div class="flex-1 ml-4">
            <div
              class="Polaris-ProgressBar Polaris-ProgressBar--sizeSmall Polaris-ProgressBar--colorHighlight"
            >
              <progress
                class="Polaris-ProgressBar__Progress"
                value="1"
                max="100"
              ></progress>
              <div
                class="Polaris-ProgressBar__Indicator Polaris-ProgressBar__IndicatorAppearDone"
                style="--pc-progress-bar-duration:500ms; --pc-progress-bar-percent:0.01;"
                :style="{
                  '--pc-progress-bar-percent': completedValue.percentage
                }"
              >
                <span class="Polaris-ProgressBar__Label"
                  >{{ completedValue.percentage }}%</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="Polaris-LegacyCard__Section"
        v-for="(feature, index) in features"
        :key="index"
      >
        <div class="flex justify-between">
          <div class="">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter Polaris-LegacyStack--noWrap_vecks"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--vertical Polaris-LegacyStack--spacingExtraTight"
                >
                  <div class="Polaris-LegacyStack__Item">
                    <span
                      class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--semibold flex"
                      >{{ feature.label }}
                      <svg
                        v-if="onboardingFlags && onboardingFlags[feature.flag]"
                        class="h-6 w-6 text-indigo-600 group-hover:text-indigo-800"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="Polaris-LegacyStack__Item">
                    <p>
                      {{ feature.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <a class="Polaris-Button" @click="gotoRoute(feature)"
              ><span class="Polaris-Button__Content"
                ><span class="Polaris-Button__Text">Manage</span></span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Redirect } from "@shopify/app-bridge/actions";

export default {
  name: "OnboardingChecklist",
  data() {
    return {
      isOpen: false,
      features: [
        {
          label: "Chat & Share",
          routeName: "Chat",
          path: "/chat",
          flag: "isChatPageVisited",
          description: "Add whatsapp chat button to your store."
        },
        {
          label: "Automated Abandoned carts",
          routeName: "AutomationConfigure",
          path: "/automation",
          flag: "isAutomatedAbandonedVisited",
          description: "Recover Abandoned checkouts automatically"
        },
        {
          label: "Automated Order confirmation",
          routeName: "OrderConfirmation",
          flag: "isAutomatedOrderConfirmationVisited",
          path: "/automation/orderconfirmation",
          description:
            "Send Order confirmation messages when the customer places an order"
        },
        {
          label: "Automated Shipping update",
          routeName: "OrderShippingUpdates",
          flag: "isAutomatedShippingUpdateVisited",
          path: "/automation/ordershipping",
          description:
            "Update your customer when the order is shipped with the tracking details."
        },
        {
          label: "Automated COD confirmation",
          routeName: "CodOrder",
          path: "/automation/codorder",
          flag: "isAutomatedCODOrderConfirmationVisited",
          description:
            "Confirm your COD orders with your customers and reduced RTO"
        },
        {
          label: "Loox integration",
          routeName: "LooxHome",
          path: "/integrations",
          flag: "isLooxIntegrationVisited",
          description:
            "Send Loox review requests on whatsapp and collect more reviews."
        }
      ]
    };
  },
  computed: {
    onboardingFlags() {
      const config = this.$store.getters.getConfig;
      if (config) {
        return config.onboardingFlags;
      }
      return {};
    },
    completedValue() {
      const flags = this.onboardingFlags;
      const features = this.features;
      const totalFeatures = features.length;
      let completedFeatures = 0;
      this.features.forEach(feature => {
        if (flags && flags[feature.flag]) {
          completedFeatures = completedFeatures + 1;
        }
      });
      const percentage = completedFeatures / totalFeatures;
      return { totalFeatures, completedFeatures, percentage };
    }
  },
  created() {
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropDropdown = false;
        this.isOpen = false;
      }
    },
    gotoRoute(route) {
      if (window.appBridgeApp) {
        const redirect = Redirect.create(window.appBridgeApp);
        redirect.dispatch(Redirect.Action.APP, route.path);
      } else {
        this.$router.push({ name: route.routeName });
      }

      this.dropDropdown = false;
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
